export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    sortable: false,
    sortField: 'name',
    label: 'field.name',
    stickyColumn: false,
    variant: 'light',
  },
  {
    key: 'username',
    sortable: false,
    sortField: 'username',
    label: 'field.username',
  },
  {
    key: 'balance',
    sortable: false,
    sortField: '',
    label: 'field.oldBalance',
    tdClass: 'text-right',
  },
  {
    key: 'withdraw',
    sortable: false,
    sortField: '',
    label: 'field.withdraw',
    tdClass: 'text-right',
  },
  {
    key: 'openBalance',
    sortable: false,
    sortField: '',
    label: 'field.openBalance',
    tdClass: 'text-right',
  },
  {
    key: 'remark',
    sortable: false,
    sortField: '',
    label: 'field.remark',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'authorizer',
    sortable: false,
    sortField: 'authorizer',
    label: 'field.createdBy',
  },
];
